// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-setting {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
}

.setting-layout {
  margin-top: 0;
}

.change-password {
  padding: 15px;
  width: 364px;
  min-height: 419px;
  background: #ffffff;
  box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15), 0px 8px 15px rgba(224, 224, 224, 0.35);
  border-radius: 15px;
}

.tilte-change-mail {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 17px;
  line-height: 22px;
  color: #121b2b;
  padding-top: 25px;
  padding-left: 15px;
}

.lable-name {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.style-input {
  font-family: "Montserrat", sans-serif;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  height: 50px;
  color: #121b2b;
}
.style-input::placeholder {
  color: #999999;
}

.button-change-setting {
  background: #1ba192;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  color: #ffffff;
}
.button-change-setting:disabled {
  background: #d5d5d5;
  cursor: not-allowed;
}

@media all and (min-width: 769px) and (max-width: 1025px) {
  .style-input {
    width: 70% !important;
  }
  .button-change-setting {
    width: 70% !important;
  }
}
@media all and (min-width: 480px) and (max-width: 768px) {
  .row-setting {
    width: 100%;
  }
  .change-password {
    width: 337px !important;
  }
}
@media all and (max-width: 480px) {
  .row-setting {
    width: 100%;
  }
  .change-password {
    width: 115% !important;
    margin-top: 20px;
  }
}
.password-toggle-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
}

input[type=password]::-ms-reveal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/main/change-password/change-password.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,2FAAA;EAEA,mBAAA;AAAF;;AAGA;EACE,qCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,qCAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,eAAA;EACA,cAAA;AADF;AAGE;EACE,mBAAA;EACA,mBAAA;AADJ;;AAKA;EACE;IACE,qBAAA;EAFF;EAKA;IACE,qBAAA;EAHF;AACF;AAMA;EACE;IACE,WAAA;EAJF;EAOA;IACE,uBAAA;EALF;AACF;AAQA;EACE;IACE,WAAA;EANF;EASA;IACE,sBAAA;IACA,gBAAA;EAPF;AACF;AASA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAPF;;AAUA;EACE,aAAA;AAPF","sourcesContent":[".row-setting {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.setting-layout {\n  margin-top: 0;\n}\n\n.change-password {\n  padding: 15px;\n  width: 364px;\n  min-height: 419px;\n  background: #ffffff;\n  box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15),\n    0px 8px 15px rgba(224, 224, 224, 0.35);\n  border-radius: 15px;\n}\n\n.tilte-change-mail {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: bold;\n  font-size: 17px;\n  line-height: 22px;\n  color: #121b2b;\n  padding-top: 25px;\n  padding-left: 15px;\n}\n\n.lable-name {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333333;\n}\n\n.style-input {\n  font-family: \"Montserrat\", sans-serif;\n  background: #ffffff;\n  border: 1px solid #d5d5d5;\n  border-radius: 5px;\n  height: 50px;\n  color: #121b2b;\n\n  &::placeholder {\n    color: #999999;\n  }\n}\n\n.button-change-setting {\n  background: #1ba192;\n  border-radius: 5px;\n  width: 100%;\n  height: 50px;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 16px;\n  color: #ffffff;\n\n  &:disabled {\n    background: #d5d5d5;\n    cursor: not-allowed;\n  }\n}\n\n@media all and (min-width: 769px) and (max-width: 1025px) {\n  .style-input {\n    width: 70% !important;\n  }\n\n  .button-change-setting {\n    width: 70% !important;\n  }\n}\n\n@media all and (min-width: 480px) and (max-width: 768px) {\n  .row-setting {\n    width: 100%;\n  }\n\n  .change-password {\n    width: 337px !important;\n  }\n}\n\n@media all and (max-width: 480px) {\n  .row-setting {\n    width: 100%;\n  }\n\n  .change-password {\n    width: 115% !important;\n    margin-top: 20px;\n  }\n}\n.password-toggle-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.54);\n}\n\ninput[type=\"password\"]::-ms-reveal {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
